<template>
  <a-upload
    name="file"
    listType="picture-card"
    :multiple="isMultiple"
    :action="uploadAction"
    :headers="headers"
    :fileList="fileList"
    :beforeUpload="beforeUpload"
    :disabled="disabled"
    :isMultiple="isMultiple"
    :showUploadList="{showDownloadIcon: true}"
    @change="handleChange"
    @preview="handlePreview"
    maxCount="1"
    accept=".png,.jpg,.jpeg,.svg,.gif">
    <!-- <img v-if="!isMultiple && picUrl" :src="getAvatarView()" style="height:104px;max-width:300px"/> -->
    <div>
      <a-icon :type="uploadLoading ? 'loading' : 'plus'" />
      <div class="ant-upload-text">{{ text }}</div>
    </div>
    <a-modal :title="$t('预览')" :visible="previewVisible" :footer="null" @cancel="handleCancel()">
      <img alt="example" style="width: 100%" :src="previewImage"/>
    </a-modal>
  </a-upload>
</template>

<script>
  import Vue from 'vue'
  import { ACCESS_TOKEN } from "@/store/mutation-types"
  import { getFileAccessHttpUrl } from '@/api/manage'
import { getAction } from '../../../../../api/manage'

  const uidGenerator=()=>{
    return '-'+parseInt(Math.random()*10000+1,10);
  }
  const getFileName=(path)=>{
    if(path.lastIndexOf("\\")>=0){
      let reg=new RegExp("\\\\","g");
      path = path.replace(reg,"/");
    }
    return path.substring(path.lastIndexOf("/")+1);
  }
  export default {
    name: 'JImageUpload',
    data(){
      return {
        uploadAction:"/jeecg-gis/customizeConfigScheme/uploadNodeIcon",
        uploadLoading:false,
        picUrl:false,
        headers:{},
        fileList: [],
        previewImage:"",
        previewVisible: false,
        url: {
          getImg: "/jeecg-gis/customizeConfigScheme/"
        }
      }
    },
    props:{
      text:{
        type:String,
        required:false,
        default:"上传"
      },
      /*这个属性用于控制文件上传的业务路径*/
      bizPath:{
        type:String,
        required:false,
        default:"temp"
      },
      value:{
        type:[String,Array],
        required:false
      },
      disabled:{
        type:Boolean,
        required:false,
        default: false
      },
      isMultiple:{
        type:Boolean,
        required:false,
        default: false
      }
    },
    watch:{
      value(val){
        if (val instanceof Array) {
          this.initFileList(val.join(','))
        } else {
          this.initFileList(val)
        }
        if(!val || val.length==0){
          this.picUrl = false;
        }
      },
      immediate: true,  // 添加这一行，使 watch 在初始渲染时立即执行
      deep: true  // 如果需要深度监听数组/对象变化，可以添加这个
    },
    created(){
      const token = Vue.ls.get(ACCESS_TOKEN);
      this.headers = {"X-Access-Token":token}
      // 添加初始值处理
      if (this.value instanceof Array) {
        this.initFileList(this.value.join(','))
      } else {
        this.initFileList(this.value)
      }
    },
    methods:{
      initFileList(paths){
        if(!paths || paths.length==0){
          this.fileList = [];
          return;
        }
        this.picUrl = true;
        let fileList = [];
        let arr = paths.split(",")
        for(var a=0;a<arr.length;a++){
          // let url = getFileAccessHttpUrl(arr[a]);
          let url = this.url.getImg+arr[a];
          fileList.push({
            uid: uidGenerator(),
            // name: getFileName(arr[a]),
            name: arr[a],
            status: 'done',
            url: url,
            response:{
              status:"history",
              message:arr[a]
            }
          })
        }
        this.fileList = fileList
      },
      beforeUpload: function(file) {
        // 1. 检查文件类型
        const fileType = file.type;
        if(fileType.indexOf('image') < 0) {
          this.$message.warning(this.$t('请上传图片'));
          return false;
        }

        // 2. 检查文件大小（限制为 2MB）
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
          this.$message.warning(this.$t('图片大小不能超过 10MB'));
          return false;
        }

        return true; // 通过验证
      },
      handleChange(info) {
        this.picUrl = false;
        let fileList = info.fileList
        if(info.file.status==='done'){
          if(info.file.response.success){
            this.picUrl = true;
            fileList = fileList.map((file) => {
              if (file.response) {
                // file.url = file.response.message;
                file.url = file.response.result.filePath.split('/')[1];
              }
              return file;
            });
          }
          //this.$message.success(`${info.file.name} 上传成功!`);
        }else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} ${this.$t('上传失败.')}`);
        }else if(info.file.status === 'removed'){
          this.handleDelete(info.file)
        }
        // this.fileList = fileList
        this.fileList = fileList.slice(-1)
        if(info.file.status==='done' || info.file.status === 'removed'){
          this.handlePathChange()
        }
      },
      // 预览
      handlePreview (file) {
        this.previewImage = file.url || file.thumbUrl
        this.previewVisible = true
      },
      getAvatarView(){
        if(this.fileList.length>0){
          return this.url.getImg+this.fileList[0].name;
          // let url = this.fileList[0].url
          // return getFileAccessHttpUrl(url)
        }
      },
      handlePathChange(){debugger
        let uploadFiles = this.fileList
        let path = ''
        if(!uploadFiles || uploadFiles.length==0){
          path = ''
        }
        let arr = [];
        if(!this.isMultiple){
          // arr.push(uploadFiles[uploadFiles.length-1].response.message)
          arr.push(uploadFiles[uploadFiles.length-1].response.result.filePath.split('/')[1])
        }else{
          for(let a=0;a<uploadFiles.length;a++){
            // update-begin-author:taoyan date:20200819 for:【开源问题z】上传图片组件 LOWCOD-783
            if(uploadFiles[a].status === 'done' ) {
              // arr.push(uploadFiles[a].response.message)
              arr.push(uploadFiles[a].response.result.filePath.split('/')[1])
            }else{
              return;
            }
            // update-end-author:taoyan date:20200819 for:【开源问题z】上传图片组件 LOWCOD-783
          }
        }
        if(arr.length>0){
          path = arr.join(",")
        }
        this.$emit('change', path);
      },
      handleDelete(file){
        //如有需要新增 删除逻辑
        console.log(file)
      },
      handleCancel() {
        this.close();
        this.previewVisible = false;
      },
      close () {

      },
    },
    model: {
      prop: 'value',
      event: 'change'
    }
  }
</script>

<style scoped>
::v-deep .ant-upload-disabled{
  display: none;
}
::v-deep .ant-upload-list-picture-card .ant-upload-list-item-info::before{
  left: 0;
}
/* ::v-deep .ant-upload-list-picture-card-container,
::v-deep .ant-upload-list-picture-card .ant-upload-list-item,
::v-deep .ant-upload.ant-upload-select-picture-card{
  width: 60px;
  height: 60px;
} */
</style>